import { render, staticRenderFns } from "./OutboxPage.vue?vue&type=template&id=9901b5f2&scoped=true&"
import script from "./OutboxPage.vue?vue&type=script&lang=js&"
export * from "./OutboxPage.vue?vue&type=script&lang=js&"
import style0 from "./OutboxPage.vue?vue&type=style&index=0&id=9901b5f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9901b5f2",
  null
  
)

export default component.exports